import { Link } from 'gatsby';
import { useContext } from 'react';
import { twMerge } from 'tailwind-merge';

import { Container } from 'components/GridV2';
import { ShortArrow } from 'components/icons';

import { trackEvent } from 'helpers';

import { LocaleContext } from './Layout';
import { P } from './Typography';

type Props = {
  heading: string;
  link: string;
  showSubheading?: boolean;
  subheading: string;
  trackName: string;
};

export const LinkBanner = ({ heading, link, showSubheading, subheading, trackName }: Props) => {
  const locale = useContext(LocaleContext);
  return (
    <Container className="w-full xs:w-full sm:w-full">
      <Link
        to={link}
        className={twMerge(
          'block h-60 w-full bg-primary-75 p-16 text-primary-400 transition-all [box-shadow:0px_4px_4px_#00000003] md:h-auto md:w-fit md:rounded-b-lg md:p-24',
          showSubheading && 'h-86 md:h-auto md:w-201',
          showSubheading && locale === 'fr' && 'md:w-300',
        )}
        onClick={() => trackEvent('Clicked', { name: trackName })}
      >
        <div className="flex items-center justify-between md:flex-col md:items-start md:justify-start">
          <div>
            <div className="flex items-center gap-4">
              <P className={twMerge('text-lg font-medium md:mb-4 md:text-md', !showSubheading && 'md:mb-0')}>
                {heading}
              </P>
              <ShortArrow className={twMerge('h-24 w-24 md:hidden', !showSubheading && 'md:block')} />
            </div>
            {showSubheading && (
              <P className={twMerge('mb-8 text-sm leading-130 text-primary-400 md:text-sm')}>{subheading}</P>
            )}
          </div>
          {showSubheading && <ShortArrow className="hidden h-20 w-20 md:block" />}
        </div>
      </Link>
    </Container>
  );
};
